import { render, staticRenderFns } from "./ExpirationStepView.vue?vue&type=template&id=36972152&scoped=true"
import script from "./ExpirationStepView.vue?vue&type=script&lang=js"
export * from "./ExpirationStepView.vue?vue&type=script&lang=js"
import style0 from "./ExpirationStepView.vue?vue&type=style&index=0&id=36972152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36972152",
  null
  
)

export default component.exports